<template>
  <div class="container main col-md-12">
    <div class = "row">
      <div class= "col-md-12">
        <h2 class ="projectTitle">{{project.title}}</h2>
      </div>
    </div>
    <div class="row authorList">
      <div class="col-sm" v-for='author in project.authors' :key='author.url'>
        <div> <a :href='author.url'> {{author.name}} </a></div>
        <div>{{author.institution}}</div>
      </div>
    </div>
    <div class = "row">
      <div class = "col-md-12 abstract">
        <p>{{project.abstract}}</p>
      </div>
    </div>
    <div class = "row">
      <div class = "col-12 paper_data">
        <span class="proceedings">In Proceedings of <a :href="project.venueURL">{{project.venue}}</a></span>
      <a class = "blocklink" :href="project.doi">DOI</a>
     <a class ="blocklink" :href="project.pdf">PDF</a>
     <a class="blocklink" :href="project.talk">Talk</a>
   </div>
    </div>
    <div class = "row">
      <div class = "col-md-12">
        <div style="padding:56.25% 0 0 0;position:relative;"><iframe :src="project.video" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectsService from '@/services/ProjectsService'
import AuthorsService from '@/services/AuthorsService'

export default {
  name: 'project',
  data () {
    return {
      airtableProjectResponse: [],
      airtableAuthorResponse: []
    }
  },
  mounted: function () {
    const self = this
    async function getProject () {
      try {
        const response = await ProjectsService.getProject(self.$route.params.slug)
        console.log(response)
        const records = response.data.records
        console.log('records', records)
        if (records.length > 0) {
          const authors = records[0].fields.author
          try {
            const response = await AuthorsService.getAuthorsById(authors)
            console.log('author response', response)
            self.airtableProjectResponse = records
            self.airtableAuthorResponse = response.data.records
          } catch (err) {
            console.log(err)
          }
        }
      } catch (err) {
        console.log(err)
      }
    }
    getProject()
  },
  computed: {
    project () {
      const self = this
      var authorList = []
      for (var i = 0; i < self.airtableAuthorResponse.length; i++) {
        const author = {
          name: self.airtableAuthorResponse[i].fields.name,
          institution: self.airtableAuthorResponse[i].fields.institution,
          url: self.airtableAuthorResponse[i].fields.url,
          id: self.airtableAuthorResponse[i].id
        }
        authorList.push(author)
      }

      if (self.airtableProjectResponse[0]) {
        const sorting = self.airtableProjectResponse[0].fields.author
        var authorResult = authorList.map(function (author) {
          var n = sorting.indexOf(author.id)
          sorting[n] = ''
          return [n, author]
        }).sort().map(function (j) { return j[1] })
        const thisProject = {
          title: self.airtableProjectResponse[0].fields.title,
          snippet: self.airtableProjectResponse[0].fields.snippet,
          images: self.airtableProjectResponse[0].fields.image,
          abstract: self.airtableProjectResponse[0].fields.abstract,
          authors: authorResult,
          video: self.airtableProjectResponse[0].fields.video + '?title=0&byline=0&portrait=0',
          doi: self.airtableProjectResponse[0].fields.doi,
          venue: self.airtableProjectResponse[0].fields.venue,
          venueURL: self.airtableProjectResponse[0].fields.venueURL,
          pdf: self.airtableProjectResponse[0].fields.pdf,
          talk: self.airtableProjectResponse[0].fields.talk
        }
        console.log(thisProject)
        return thisProject
      }
      return {}
    }
  }
}
</script>
